import { LoadablePaint } from '@confluence/loadable';

export const ForgeGlobalPageExtensionPoint = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GlobalPage" */ './GlobalPage')).GlobalPage,
});
